import { hideLoading, showLoading } from 'assets/core/js/module/button-loading'

export default function (): void {
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      document.querySelectorAll<HTMLButtonElement>('.dca-button--with-loading[disabled]').forEach((el) => {
        hideLoading(el)
      })
    }
  })

  document.addEventListener('click', function (e): void {
    const target = e.target as HTMLElement

    if (target?.hasAttribute('data-check-offer')) {
      e.preventDefault()

      const submitEl = document
        .querySelector(`form[data-check-offer-id="${target.getAttribute('data-check-offer') as string}"]`)
        ?.querySelector<HTMLButtonElement>('[type="submit"]')

      if (!submitEl) {
        return
      }

      if (target.classList.contains('dca-button--with-loading')) {
        showLoading(target as HTMLButtonElement)
      }

      submitEl.click()
    }
  })
}
